<template>
  <div class="wrap">
    <div class="nav">
      <p>BLA</p>
    </div>
    <div class="main">
      <top-page-1 v-if="first || arr_length == 0" />
      <top-page-2 v-if="arr_length > 0" :my_arr="my_appliances" />
      <div class="center">
        <div class="in">
          <div class="iin">
            <div class="first_page" v-if="first">
              <counters />
              <appliances @applianceClicked="onApplianceClicked" />
              <situations />
            </div>
            <div class="second_page" v-if="second">
              <new-appliance :selected="selected_appliance" @applianceForm="onApplianceFormMain" />
            </div>
            <div class="third_page" v-if="third">
              <add-appliance :selected="selected_form" />
            </div>
            <div class="fourth_page" v-if="fourth">
              <final-page />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Counters from './Counters.vue';
import Appliances from './Appliances.vue';
import Situations from './Situations.vue';
import NewAppliance from './NewAppliance.vue';
import AddAppliance from './AddAppliance.vue';
import FinalPage from './FinalPage.vue';
import TopPage1 from './TopPage1.vue';
import TopPage2 from './TopPage2.vue';

export default {
  name: 'Calculator',
  components: {
    Situations,
    Appliances,
    Counters,
    NewAppliance,
    AddAppliance,
    FinalPage,
    TopPage1,
    TopPage2,
  },
  data: function () {
    return {
      selected_appliance: 0,
      selected_form: 0,
      first: true,
      second: false,
      third: false,
      fourth: false,

      arr_length: 0,

      my_appliances: {
        H: [],
        PS: [],
        Z: [],
        PX: [],
        SS: [],
        PGV: [],
        R: [],
        T: [],
        TV: [],
        P: [],
        AC: [],
      },
    };
  },
  methods: {
    onApplianceClicked(x) {
      this.selected_appliance = x;
      this.second = true;
      this.first = false;
      this.third = false;
    },
    onApplianceFormMain(x) {
      this.selected_form = x.st_select;
      this.my_appliances[x.short].push(x);
      this.arr_length += 1;
      this.second = false;
      this.first = false;
      this.third = true;
    },
  },
};
</script>

<style>
</style>
